import { useEffect, useMemo, useState } from "react";
import VehicleService from "../../services/vehicle-service";
import IVehicle from "../../types/vehicle-type";
import { useIntl } from "react-intl";
import { VehicleType } from "../../utils/vehicleTypes";

export const useVehicleFunctions = () => {
  const [, setVehicles] = useState<IVehicle[]>([]);
  const [cars, setCars] = useState<IVehicle[]>([]);
  const [rvs, setRvs] = useState<IVehicle[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadVehicles = async () => {
    setIsLoading(true);
    try {
      const response = await VehicleService.getAllVehicles();
      const vehicles = response.data;
      setVehicles(vehicles);
      setCars(vehicles.filter((vehicle: IVehicle) => vehicle.vehicleType === 'car'));
      setRvs(vehicles.filter((vehicle: IVehicle) => vehicle.vehicleType === 'rv'));
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const TranslatedVehicleOptions = (
    vehicleTypes: VehicleType[],
    vehicleType: string
  ) => {
    const intl = useIntl();

    const filteredVehicleTypes = vehicleTypes.filter(
      (type) => type.group === vehicleType
    );
  
    const translatedVehicles = filteredVehicleTypes.map((type) => ({
      ...type,
      translatedLabel: intl.formatMessage({ id: type.labelId })
    }));
  
    const sortedVehicles = translatedVehicles.sort((a, b) => a.translatedLabel.localeCompare(b.translatedLabel));

    return useMemo(() => 
        sortedVehicles.map(option => ({
          ...option,
          label: intl.formatMessage({ id: option.labelId, defaultMessage: option.labelId })
        })),
        [sortedVehicles, intl]
      );
  };

  useEffect(() => {
    loadVehicles();
  }, []);

  return {
    cars,
    rvs,
    isLoading,
    setVehicles,
    loadVehicles,
    TranslatedVehicleOptions
  };
};